import { Button, Col, Modal, Row, Space, Typography } from "antd";
import useSignOut from "../../lib/hooks/useSignout";

import CloseIcon from "../../assets/images/icon/closeIcon.svg";
import SuccessIcon from "../../assets/images/icon/successIcon.svg";

const { Title, Text } = Typography;

const ModalResponse = ({ open, setOpen, title, subTitle, type }) => {
  const { setSignout } = useSignOut();

  const handleCancel = () => {
    if (type) {
      setSignout(true);
    }

    setOpen({
      show: false,
    });
  };

  return (
    <Modal
      open={open}
      title=""
      onCancel={handleCancel}
      footer={false}
      width={400}
    >
      <Space
        direction="horizontal"
        style={{ width: "100%", justifyContent: "center", marginTop: 30 }}
      >
        <img src={type ? SuccessIcon : CloseIcon} width={80} alt="Modal Icon" />
      </Space>

      <Row justify="center">
        <Col span={24} align="center">
          <Title level={5}>{title || "มีบางอย่างผิดพลาด"}</Title>
        </Col>
        <Col span={24} align="center">
          <Text className="sub-title">
            {subTitle || "มีบางอย่างผิดพลาด โปรดทำรายการอีกครั้ง"}
          </Text>
        </Col>
      </Row>

      <Space
        direction="horizontal"
        style={{
          width: "100%",
          justifyContent: "center",
          marginTop: 20,
          marginBottom: 20,
        }}
      >
        <Button key="back" type="primary" onClick={handleCancel}>
          {type ? "เข้าสู่ระบบ" : "ตกลง"}
        </Button>
      </Space>
    </Modal>
  );
};

export default ModalResponse;
